<template>
  <div id="app">

    <!-- PRELOADER -->
    <div
      v-if="preloaderVisible"
      class="app-preloader"
      :class="{ hiding: preloaderHiding }"
      aria-hidden="true"
    >
      <div class="preloader-core">
        <span class="preloader-ring ring-outer"></span>
        <span class="preloader-ring ring-inner"></span>
        <svg class="preloader-raptor" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <!-- cola -->
          <polygon points="4,50 34,42 34,56" fill="#4a5a23" />
          <!-- pata trasera (impulso) -->
          <polygon points="38,54 26,70 32,75 42,58" fill="#4a5a23" />
          <!-- garra curva (rasgo distintivo del velociraptor) -->
          <path d="M53,74 Q60,68 58,60 Q55,67 50,72 Z" fill="#4a5a23" />
          <!-- pata delantera (apoyo) -->
          <polygon points="50,56 45,78 53,81 58,58" fill="#4a5a23" />
          <!-- cuerpo -->
          <ellipse cx="48" cy="48" rx="18" ry="11" transform="rotate(-12 48 48)" fill="#4a5a23" />
          <!-- brazo corto -->
          <polygon points="52,44 46,50 50,53 55,47" fill="#4a5a23" />
          <!-- cuello y cabeza con hocico entreabierto -->
          <path d="M56,40 Q64,18 80,14 Q90,18 96,26 Q88,30 82,28 Q76,32 70,30 Q62,34 58,48 Z" fill="#4a5a23" />
          <!-- ojo -->
          <circle cx="84" cy="20" r="2.2" fill="#0a0a08" />
        </svg>
      </div>
      <span class="preloader-word">RAPTORIS</span>
    </div>

    <!-- COOKIE BANNER -->
    <CookieBannerComponent
      @accepted="activarAnalytica"
      @rejected="rechazarAnalytica"
    />

    <!-- WHATSAPP FLOTANTE -->
    <WhatsAppFloatButton />

    <!-- HEADER -->
    <header>
      <NavBarComponent />
    </header>


    <!-- MAIN -->
    <main>
      <router-view />
    </main>

    <!-- FOOTER -->
    <footer class="footer">

      <!-- GEOMETRÍA: escamas de reptil, difuminadas -arcos reales en un
           <pattern> de SVG (sin viewBox, se repiten a su tamaño real en
           píxeles), dos filas por tile con desfase de medio ancho para que
           se traslapen tipo escama, y un feGaussianBlur encima para que se
           vean suaves/atmosféricas en vez de líneas duras. -->
      <div class="footer-geo" aria-hidden="true">
        <svg class="footer-geo__scales">
          <defs>
            <pattern id="footerScaleTile" width="40" height="48" patternUnits="userSpaceOnUse">
              <path class="footer-geo__scale" d="M0,24 Q20,8 40,24 L40,48 L0,48 Z" />
              <path class="footer-geo__scale" d="M0,0 Q10,-16 20,0 Q30,-16 40,0 L40,24 L0,24 Z" />
            </pattern>
            <linearGradient id="footerScaleFade" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="#fff" stop-opacity="1" />
              <stop offset="40%" stop-color="#fff" stop-opacity="0" />
            </linearGradient>
            <mask id="footerScaleMask">
              <rect width="100%" height="100%" fill="url(#footerScaleFade)" />
            </mask>
            <filter id="footerScaleBlur" x="-20%" y="-20%" width="140%" height="140%">
              <feGaussianBlur stdDeviation="4.5" />
            </filter>
          </defs>
          <rect
            width="100%"
            height="100%"
            fill="url(#footerScaleTile)"
            mask="url(#footerScaleMask)"
            filter="url(#footerScaleBlur)"
          />
        </svg>
      </div>

      <!-- LEFT -->
      <div class="footer-left">

        <div>
          <p>&copy; {{ currentYear }} Raptoris.</p>
          <p>Email: info@raptoris.com</p>
        </div>

        <!-- SOCIALS -->
        <div class="social-icons">

          <!-- INSTAGRAM -->
          <a
            href="https://www.instagram.com/raptorisstore/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#000000"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" />
              <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
              <path d="M16.5 7.5l0 .01" />
            </svg>
          </a>

          <!-- FACEBOOK -->
          <a
            href="https://www.facebook.com/profile.php?id=61577349881673"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#000000"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
            </svg>
          </a>

        </div>

        <h4>{{ $t('footer.follow_us') }}</h4>

      </div>

      <!-- FOOTER LINKS -->
      <div class="footer-links">

        <router-link to="/nosotros">
          {{ $t('footer.about') }}
        </router-link>

        <router-link to="/faqs">
          {{ $t('footer.frequently_asked_questions') }}
        </router-link>

        <router-link to="/contacto">
          {{ $t('footer.contact') }}
        </router-link>

        <router-link to="/aviso-privacidad">
          {{ $t('footer.privacy') }}
        </router-link>

      </div>

    </footer>

  </div>
</template>

<script>
import NavBarComponent from "@/views/NavBarComponent.vue";
import CookieBannerComponent from "@/components/CookieBannerComponent.vue";
import WhatsAppFloatButton from "@/components/WhatsAppFloatButton.vue";

export default {

  name: "App",

  components: {
    NavBarComponent,
    CookieBannerComponent,
    WhatsAppFloatButton
  },

  data() {
    // El preloader retrasaba el primer render 1.7 s en TODA visita. En móvil,
    // que es de donde viene la mayoría del tráfico, eso se traduce directo en
    // LCP y en gente que se va antes de ver nada (hallazgo C-8). Se omite en
    // pantallas chicas, con "reduce motion" activado y en conexiones lentas;
    // en escritorio se conserva, pero más corto.
    const skipPreloader =
      typeof window !== 'undefined' && (
        window.matchMedia('(max-width: 768px)').matches ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        (navigator.connection && (
          navigator.connection.saveData === true ||
          ['slow-2g', '2g', '3g'].includes(navigator.connection.effectiveType)
        ))
      );

    return {
      currentYear: new Date().getFullYear(),
      skipPreloader,
      preloaderVisible: !skipPreloader,
      preloaderHiding: false
    };
  },

  mounted() {
    if (this.skipPreloader) return;
    setTimeout(() => { this.preloaderHiding = true; }, 550);
    setTimeout(() => { this.preloaderVisible = false; }, 950);
  },

  methods: {
    activarAnalytica() {
      if (window.__raptorisEnableTracking) {
        window.__raptorisEnableTracking();
      }
    },

    rechazarAnalytica() {
      // Desactiva cookies de analítica y de anuncios (ver public/index.html).
      if (window.__raptorisRejectTracking) {
        window.__raptorisRejectTracking();
      }
    }
  }
};
</script>

<style>

@import './assets/styles/main.css';
@import './assets/styles/normalize.css';

/* ===== PRELOADER ===== */

.app-preloader {
  position: fixed;
  inset: 0;
  z-index: 9999;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.4rem;

  background: radial-gradient(circle at 50% 42%, #1f2712 0%, #0a0b06 72%);

  opacity: 1;
  visibility: visible;
  transition: opacity .6s ease, visibility .6s ease;
}

.app-preloader.hiding {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.preloader-core {
  position: relative;
  width: 92px;
  height: 92px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Anillo metálico girando en sentido horario */
.preloader-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid transparent;
  animation: preloaderSpin 1.15s linear infinite;
}

.ring-outer {
  border-top-color: #eef0e7;
  border-right-color: rgba(220, 223, 210, .35);
  border-bottom-color: rgba(151, 165, 101, .12);
}

.ring-inner {
  inset: 12px;
  border-top-color: #97a565;
  border-right-color: rgba(151, 165, 101, .25);
  animation-duration: 1.7s;
}

@keyframes preloaderSpin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

.preloader-raptor {
  position: relative;
  width: 40px;
  height: 40px;
  animation: preloaderPulse 1.4s ease-in-out infinite alternate;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, .5));
}

@keyframes preloaderPulse {
  from { transform: scale(1); }
  to   { transform: scale(1.07); }
}

.preloader-word {
  background: linear-gradient(110deg, #787d6c 20%, #f5f6f0 40%, #ffffff 50%, #f5f6f0 60%, #787d6c 80%);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 800;
  font-size: 1.1rem;
  letter-spacing: 4px;
  animation: preloaderShimmer 2.6s linear infinite;
}

@keyframes preloaderShimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@media (prefers-reduced-motion: reduce) {
  .preloader-ring,
  .preloader-raptor,
  .preloader-word {
    animation: none;
  }
}

/* APP */
#app{
  min-height:100vh;
  display:flex;
  flex-direction:column;
}

main{
  flex:1;
}

/* FOOTER */
.footer{

  position:relative;

  padding:2.5rem 2rem 1.2rem;

  /* Mismo degradado que la barra de navegación, pero con el último tono
     empujado más allá del 100%: así nunca se alcanza a mostrar completo
     dentro de la caja, sin importar qué tan ancho/alto sea el footer -es
     lo que hacía que se viera más verde que la barra (una caja más
     cuadrada que la barra deja ver mucho más ese tramo final del
     degradado). */
  background:
    linear-gradient(
      135deg,
      #0a0b06 0%,
      #141a0c 70%,
      #1f2712 150%
    );

  color:white;

  display:grid;

  grid-template-columns:1fr auto;

  align-items:center;

  gap:2rem;

  border-top:
    1px solid rgba(255,255,255,.08);

  box-shadow:
    0 -8px 25px rgba(0,0,0,.12);

  overflow:hidden;
}

/* GLOW */
.footer::before{

  content:"";

  position:absolute;

  top:-120px;
  right:-100px;

  width:240px;
  height:240px;

  background:
    radial-gradient(
      circle,
      rgba(74, 90, 35,.12),
      transparent 70%
    );

  pointer-events:none;
}

/* GEOMETRÍA: escamas de reptil -encaja con "Raptoris" mejor que rayas
   sueltas. Sin viewBox en el <svg>: el <pattern> se repite a su tamaño
   real en píxeles (40x48), nunca se estira. */
.footer-geo{

  position:absolute;
  inset:0;

  overflow:hidden;

  pointer-events:none;

  z-index:-1;
}

.footer-geo__scales{
  display:block;
  width:100%;
  height:100%;
}

.footer-geo__scale{
  /* La barra de navegación usa este mismo verde solo en detalles puntuales
     (un botón, una línea de 1px) sobre un fondo casi negro -no como un
     lavado de color. Bajado otra vez para que el footer se sienta del
     mismo tono oscuro, con apenas un indicio de textura, no una franja
     verde encima. */
  fill:rgba(151,165,101,.05);
  stroke:rgba(151,165,101,.12);
  stroke-width:1;
}

/* LEFT */
.footer-left{

  display:flex;

  flex-direction:column;

  gap:.8rem;

  z-index:2;
}

.footer p{

  margin:0;

  font-size:.88rem;

  color:rgba(255,255,255,.75);

  line-height:1.6;

  letter-spacing:.3px;
}

/* FOLLOW */
.footer h4{

  margin:0;

  font-size:.8rem;

  font-weight:500;

  letter-spacing:2px;

  text-transform:uppercase;

  color:#dde1cc;
}

/* SOCIALS */
.social-icons{

  display:flex;

  gap:.8rem;
}

.social-icons a{

  width:42px;
  height:42px;

  display:flex;

  align-items:center;
  justify-content:center;

  border-radius:50%;

  background:rgba(255,255,255,.05);

  border:
    1px solid rgba(255,255,255,.08);

  transition:all .3s ease;
}

.social-icons a svg{

  width:20px;
  height:20px;

  stroke:white;

  transition:.3s;
}

.social-icons a:hover{

  transform:translateY(-3px);

  background:rgba(74, 90, 35,.25);

  box-shadow:
    0 8px 18px rgba(0,0,0,.2);
}

/* LINKS */
.footer-links{

  display:flex;

  gap:2rem;

  z-index:2;
}

.footer-links a{

  color:rgba(255,255,255,.78);

  text-decoration:none;

  font-size:.92rem;

  font-weight:400;

  letter-spacing:.3px;

  position:relative;

  transition:.3s;
}

.footer-links a::after{

  content:"";

  position:absolute;

  left:0;
  bottom:-5px;

  width:0;
  height:1px;

  background:#dde1cc;

  transition:.3s;
}

.footer-links a:hover{
  color:white;
}

.footer-links a:hover::after{
  width:100%;
}

/* SIGNATURE */
.footer::after{

  content:"Diseñado para crecer contigo";

  position:absolute;

  bottom:8px;
  left:50%;

  transform:translateX(-50%);

  font-size:.58rem;

  letter-spacing:2px;

  text-transform:uppercase;

  color:rgba(255,255,255,.22);
}

/* TABLET */
@media (max-width:900px){

  .footer{

    grid-template-columns:1fr;

    text-align:center;

    gap:1.5rem;
  }

  .footer-left{
    align-items:center;
  }

  .footer-links{

    justify-content:center;

    flex-wrap:wrap;

    gap:1.5rem;
  }
}

/* MOBILE */
@media (max-width:768px){

  .footer{
    padding:2rem 1rem 1rem;
  }

  .social-icons a{
    width:38px;
    height:38px;
  }

  .social-icons a svg{
    width:18px;
    height:18px;
  }

  .footer p{
    font-size:.8rem;
  }

  .footer-links a{
    font-size:.85rem;
  }

  .footer::after{
    font-size:.5rem;
  }
}

</style>